import { RootDispatch, RootGetState, NavigationStep } from "../types";
import history from "../../history";
import { initiateVideoChat } from "../videoChat/actions";
import { post } from "../../utils/fetch";
import { PatientFormParams, cleanPatientResponse, PatientResponse } from "../patient/types";
import { VideoChatInviteMode } from "../videoChat/types";

export type Action =
  | { type: "quickContact/quickContact-started" }
  | { type: "quickContact/quickContact-success" }
  | { type: "quickContact/quickContact-failure" };

export const quickContact = (patient: PatientFormParams, step: NavigationStep) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "quickContact/quickContact-started"
  });

  const url = "/api/organization/" + getState().orgs.currentOrganization?.id + "/patients/";

  const resp = await post<PatientResponse>(url, patient);

  if (resp.error) {
    dispatch({
      type: "quickContact/quickContact-failure",
      error: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "quickContact/quickContact-success"
    });
    dispatch({
      type: "patient/setPatient",
      patient: cleanPatientResponse(resp.data)
    });

    switch (step) {
      case NavigationStep.MessagePatient:
        history.push(`/patient/${resp.data.id}/message/`);
        break;
      case NavigationStep.VideoChatSms:
        dispatch(initiateVideoChat(VideoChatInviteMode.Sms));
        break;
      case NavigationStep.VideoChatEmail:
        dispatch(initiateVideoChat(VideoChatInviteMode.Email));
        break;
    }
  } else {
    // TODO Logging
  }
};
